export class SignDto {

  name: String = ''; // 이름
  position: String = ''; // 직함
  department: String = ''; // 부서

  mobileNumber1: String = ''; // 모바일 번호 맨 앞
  mobileNumber2: String = ''; // 모바일 번호 중간
  mobileNumber3: String = ''; // 모바일 번호 맨 뒤

  faxNumber1: String = '02'; // 팩스 번호 맨 앞
  faxNumber2: String = '585'; // 팩스 번호 중간
  faxNumber3: String = '5155'; // 팩스 번호 맨 뒤

  extensionNumber1: String = ''; // 직통 번호 맨 앞
  extensionNumber2: String = ''; // 직통 번호 중간
  extensionNumber3: String = ''; // 직통 번호 맨 뒤

  email: String = ''; // 이메일
  imageType: String = 'gaea_all'; // 이미지 타입


}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/model/sign/sign-dto.ts